import React, { PureComponent, Component } from 'react';
import ReactTable from 'react-table';
import 'react-table/react-table.css';

class SegmentTable extends Component {
    constructor() {
        super();
        this.state = {
            segment: []
        }
    }

    componentWillReceiveProps() {
        let aTempSegment = [];
        outterloop: for (let i = 0; i < this.props.schedulesBrief.length; i++) {
            if (this.props.schedulesBrief[i].selected) {
                for (let j = 0; j < this.props.schedules.length; j++) {
                    if (this.props.schedules[j].res_num === this.props.schedulesBrief[i].res_num) {
                        aTempSegment.push(this.props.schedules[j]);
                    } else if (aTempSegment != null && aTempSegment.length != 0) {
                        break outterloop;
                    }
                }
            }
        }
        if (aTempSegment != null && aTempSegment.length != 0) {
            if (document.getElementById("myRightBottomNav").hidden) {
                document.getElementById("myRightBottomNav").hidden = false;
            }
            aTempSegment.push({

            });
        } else {
            if (!document.getElementById("myRightBottomNav").hidden) {
                document.getElementById("myRightBottomNav").hidden = true;
            }
        }
        this.setState({ segment: aTempSegment });
    }

    

    render() {
        const columns = [{
            Header: 'ETA',
            id: 'eta',
            accessor: 'eta',
            Cell: row => (this.convertMinutesToAmPm(parseInt(row.value, 10))),
            maxWidth: 58
        }, {
            Header: 'ETD',
            id: 'etd',
            accessor: 'etd',
            Cell: row => (this.convertMinutesToAmPm(parseInt(row.value, 10))),
            maxWidth: 58
        }, {
            Header: 'Trip Time',
            id: 'triptime',
            accessor: 'triptime',
            Cell: row => (this.convertMinutesToAmPm(parseInt(row.value, 10))),
            maxWidth: 86
        }, {
            Header: 'Trip ID',
            id: 'trip_id',
            accessor: 'trip_id',
            maxWidth: 106
        }];
        return (
            <ReactTable
                // data={data}
                data={this.state.segment}
                columns={columns}
                style={{
                    height: "81%", // This will force the table body to overflow and scroll, since there is not enough room
                    width: "306px"
                }}
                // defaultPageSize={this.state.segment ? this.state.segment.length : 0}
                defaultPageSize={-1}
                showPagination={false}
                className="-striped -highlight"
            >
            </ReactTable>
        );
    }

    convertMinutesToAmPm(theMins) {
        let aIsAm = true;
        if (theMins >= 12 * 60) {
            aIsAm = false;
        }
        let aHr = 0, aMin = 0;
        let aHrStr = "", aMinStr = "";
        if (aIsAm) {
            if (aIsAm === 0) {
                return "0000A";
            }
            aHr = Math.floor(theMins / 60);
            aMin = theMins % 60;
            if (aHr < 10) {
                aHrStr = "0" + aHr.toString();
            } else {
                aHrStr = aHr.toString();
            }
            if (aMin < 10) {
                aMinStr = "0" + aMin.toString();
            } else {
                aMinStr = aMin.toString();
            }
            return aHrStr + aMinStr + "A";
        } else {
            if (theMins === 12 * 60) {
                return "1200P";
            }
            aHr = Math.floor((theMins - 12 * 60) / 60);
            aMin = (theMins - 12 * 60) % 60;
            if (aHr < 10) {
                if (aHr === 0) {
                    aHrStr = "12";
                } else {
                    aHrStr = "0" + aHr.toString();
                }
            } else {
                aHrStr = aHr.toString();
            }
            if (aMin < 10) {
                aMinStr = "0" + aMin.toString();
            } else {
                aMinStr = aMin.toString();
            }
            return aHrStr + aMinStr + "P";
        }
    }
}

export default SegmentTable;



// WEBPACK FOOTER //
// ./src/Componets/SegmentTable.js